import { BundleResourcesPackage } from "resource-system";
import { Spritesheet } from "pixi.js";
import { Texture } from "@pixi/core";
export class LoseResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("LoseResourcesPackage");
    }
    public get assets_popups_lose_lose_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/popups/lose/lose_1x.atlas.json");
    }
    public get assets_popups_lose_orange_ribbon_png(): Texture {
        return this.assets_popups_lose_lose_1x_atlas_json.textures["orange_ribbon.png"];
    }
    public get assets_popups_lose_lose_frame_png(): Texture {
        return this.assets_popups_lose_lose_1x_atlas_json.textures["lose_frame.png"];
    }
    public get assets_popups_lose_reason_substrate_png(): Texture {
        return this.assets_popups_lose_lose_1x_atlas_json.textures["reason/substrate.png"];
    }
    public get assets_popups_lose_reason_mole_icon_png(): Texture {
        return this.assets_popups_lose_lose_1x_atlas_json.textures["reason/mole_icon.png"];
    }
    public get assets_popups_lose_reason_vegetable_icon_png(): Texture {
        return this.assets_popups_lose_lose_1x_atlas_json.textures["reason/vegetable_icon.png"];
    }
    public get assets_popups_lose_resurrect_icon_png(): Texture {
        return this.assets_popups_lose_lose_1x_atlas_json.textures["resurrect_icon.png"];
    }
    public get assets_popups_lose_lose_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/popups/lose/lose_1x.atlas.png");
    }
}

